import { Button } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { trackShowMoreArticles } from "reusable/ChargeGTM";
import { NewText } from "ui";
import { sharedColors } from "ui/theme/colors";

type Props = {
    itemsLimit?: number,
    onClickHandler: () => void
}
function MoreArticlesButton({ onClickHandler }: Props) {

    return (
        <Button
            id="basic-button"
            variant="outlined"
            sx={{ borderRadius: '50px', borderColor: sharedColors.blue }} // Adjust the value as needed
            onClick={onClickHandler}
        >
            <NewText
                component={"p"}
                largeDesktopFontSize={16}
                largeDesktopLineHeight="18px"
                desktopFontSize={16}
                desktopLineHeight={"18px"}
                mobileFontSize={18}
                mobileLineHeight={"18px"}
                desktopFontWeight={500}
                color={sharedColors.blue}
            >
                הראו לי עוד כתבות
            </NewText>
        </Button>
    );
}
export default MoreArticlesButton;
